export default "__VITE_ASSET__E98ST5EC__"